<!-- actions -->
<cart-orders-actions (editCart)="onEditCart()" [config]="actionsConf"></cart-orders-actions>
<!-- /actions -->

@if (isMiniCart) {
  <div>
    <ng-scrollbar  class="mb-0 cart_order_list" track="vertical">
      <ng-container *ngTemplateOutlet="cartOrderList"></ng-container>
    </ng-scrollbar>
  </div>
}

@if (!isMiniCart) {
  <div>
    <div class="mb-0">
      <ng-container *ngTemplateOutlet="cartOrderList"></ng-container>
    </div>
  </div>
}

<ng-template #cartOrderList>
  @for (item of items.TransactionItems | ProductPipe: 'ParentLineId': null; track item) {
    <div class="item-wrap">
      <div class="media">
        @if (!hideProductImageBox) {
          <img product-image
            [product]="item"
            [size]="'Sma'"
            class="img-fluid"/>
        }
        <div class="media-body mx-2">
          <h5 class="item-description mt-0" [innerHTML]="item.ItemDescription"></h5>
          <p class="text-muted"><span translate>Barcode</span>: {{item.Barcode}}</p>
        </div>
      </div>
      <!--kit itmes -->
      @if (item.children.length) {
        <p (click)="$event.preventDefault(); $event.stopPropagation();">
          <span translate>Kit Includes</span>
          <span (click)="item.isOpen =! item.isOpen;" class="mx-2">
            @if (!item.isOpen) {
              <i class="fa fa-plus-circle" tooltip="{{'Show items in kit'|translate}}"></i>
            }
            @if (item.isOpen) {
              <i class="fa fa-minus-circle" tooltip="{{'Hide'|translate}}"></i>
            }
          </span>
        </p>
      }
      @if (item.isOpen) {
        <ul class="list-unstyled px-2 kit-items">
          @for (kitItem of item.children; track kitItem) {
            <li class="media">
              @if (!hideProductImageBox) {
                <img product-image
                  [product]="kitItem"
                  [size]="'Sma'"
                  class="img-fluid"/>
              }
              <div class="media-body mx-2">
                <div class="row align-items-center">
                  <div class="col">
                    <p class="tem-description" [innerHtml]="kitItem.ItemDescription"></p>
                    <p class="text-muted"><span translate>Barcode</span>: {{kitItem.Barcode}}</p>
                  </div>
                  <div class="col-auto">&times;</div>
                  <div class="col-auto">{{kitItem.ItemQuantity}}</div>
                </div>
              </div>
            </li>
          }
        </ul>
      }
      <!-- /kit items-->
      <p><span translate>Quantity</span>:&nbsp;<span dir="ltr">{{item.ItemQuantity}}</span></p>
      <p><span translate>Price</span>: {{item.PricePerItem?.value !== -1 ? (item.PricePerItem.value|currency:item.PricePerItem.currency:'symbol') : 'POA'}}</p>
      @if (item.PricePerItem?.striped !== -1) {
        <p class="striped-price">{{item.PricePerItem.striped |currency:item.PricePerItem.currency:'symbol'}}</p>
      }
      @if (item.DiscountPercent > 0) {
        <p>
          <span translate>Discount</span>: {{item.DiscountPercent}}%
        </p>
      }
      @if (item.DiscountPercent > 0 || item.PricePerItem != item.TotalPrice) {
        <p>
          <span translate>Total Price</span>: {{item.PricePerItem?.currency ? (item.TotalPrice |currency:item.PricePerItem?.currency:'symbol') : item.TotalPrice}}
        </p>
      }
    </div>
  }
</ng-template>
